module.exports = __webpack_public_path__ + "static/media/email.cd107d62.svg";